import './spacer.less'

import m from 'mithril'
import {classes, Component} from '@codeurs/front'

export default class Spacer extends Component<{
	mod?: string
}> {
	view() {
		const {mod} = this.attrs
		return m('.spacer', classes({mod}))
	}
}
